import './../scss/style.scss';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/collapse';
import modernizr from '../../../modernizr-config';
import 'object-fit-images';
import 'jquery';

jQuery(document).ready(function ($) {
  $('[data-hover-background]').each(function () {
    let hover = $(this).css('background-color');
    $(this).hover(function () {
      $(this).css('background-color', $(this).data('hover-background'));
    }, function () {
      $(this).css('background-color', hover);
    })
  });
});
